import './App.css';
import './css/all.min.css';
import './css/all.css';
import './css/flexslider.css';
import './css/jquery.mmenu.all.css';
import './css/jquery.rateyo.css';
import './css/lightbox.css';
import './css/meanmenu.min.css';
import './css/owl.carousel.css';
import './css/owl.theme.default.css';
import './style.css';
import './inner-page-style.css';



import { Routes, Route } from 'react-router-dom'
import { Login } from "./components/Login";
import { Register } from "./components/Register";
import Home from './components/Home';
import { ProtectedRoute } from "./components/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";
import Thanks from './components/Thanks';
import Autoriza from './components/Authorize'
import Dashboard from './components/Dashboard';

import AdminSlides from './components/admin-slides/Slides'
import AdminSlidesAdd from './components/admin-slides/SlidesAdd'
import AdminSlidesEdit from './components/admin-slides/SlidesEdit'

import AdminPacks from './components/admin-packs/Packs'
import AdminPacksAdd from './components/admin-packs/PacksAdd'
import AdminPacksEdit from './components/admin-packs/PacksEdit'

import AdminGalery from './components/admin-galery/Galery'
import AdminGaleryAdd from './components/admin-galery/GaleryAdd'
import AdminGaleryEdit from './components/admin-galery/GaleryEdit'

import AdminEvents from './components/admin-events/Events'
import AdminEventsAdd from './components/admin-events/EventsAdd'
import AdminEventsEdit from './components/admin-events/EventsEdit'

import PruebaCrud from './components/prueba/Show'
import PruebaCrudAdd from './components/prueba/Create'
import PruebaCrudEdit from './components/prueba/Edit'

import Inventario from './components/admin-inventario/Inventario'
import InventarioAdd from './components/admin-inventario/InventarioAdd'
import InventarioEdit from './components/admin-inventario/InventarioEdit'


function App() {
  return (
    <AuthProvider>
    <Routes>
      <Route path="/login" exact  element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/thanks" element={<Thanks/>} />
      <Route path="/" element={<Home />} />
      <Route 
        path="/admin-page"
        element={
        <ProtectedRoute>
          <Dashboard/>
        </ProtectedRoute>
        }
      />
      <Route 
        path="/admin-slides"
        element={
        <ProtectedRoute>
          <AdminSlides/>
        </ProtectedRoute>
        }
      />
      <Route 
        path="/admin-slides-edit/:id"
        element={
        <ProtectedRoute>
          <AdminSlidesEdit/>
        </ProtectedRoute>
        }
      />
    <Route 
        path="/admin-slides-add"
        element={
        <ProtectedRoute>
          <AdminSlidesAdd/>
        </ProtectedRoute>
        }
      />
            <Route 
        path="/admin-packs"
        element={
        <ProtectedRoute>
          <AdminPacks/>
        </ProtectedRoute>
        }
      />
      <Route 
        path="/admin-packs-edit/:id"
        element={
        <ProtectedRoute>
          <AdminPacksEdit/>
        </ProtectedRoute>
        }
      />
    <Route 
        path="/admin-packs-add"
        element={
        <ProtectedRoute>
          <AdminPacksAdd/>
        </ProtectedRoute>
        }
      />
        <Route 
        path="/admin-galery"
        element={
        <ProtectedRoute>
          <AdminGalery/>
        </ProtectedRoute>
        }
      />
      <Route 
        path="/admin-galery-edit"
        element={
        <ProtectedRoute>
          <AdminGaleryEdit/>
        </ProtectedRoute>
        }
      />
    <Route 
        path="/admin-galery-add"
        element={
        <ProtectedRoute>
          <AdminGaleryAdd/>
        </ProtectedRoute>
        }
      />
            <Route 
        path="/admin-events"
        element={
        <ProtectedRoute>
          <AdminEvents/>
        </ProtectedRoute>
        }
      />
      <Route 
        path="/admin-events-edit/:id"
        element={
        <ProtectedRoute>
          <AdminEventsEdit/>
        </ProtectedRoute>
        }
      />
    <Route 
        path="/admin-events-add"
        element={
        <ProtectedRoute>
          <AdminEventsAdd/>
        </ProtectedRoute>
        }
      />

    <Route 
        path="/prueba-crud"
        element={
        <ProtectedRoute>
          <PruebaCrud/>
        </ProtectedRoute>
        }
      />
    <Route 
        path="/prueba-crud-edit/:id"
        element={
        <ProtectedRoute>
          <PruebaCrudEdit/>
        </ProtectedRoute>
        }
      />
    <Route 
        path="/prueba-crud-add"
        element={
        <ProtectedRoute>
          <PruebaCrudAdd/>
        </ProtectedRoute>
        }
      />

    <Route
      path="/admin-inventario"
      element={
        <ProtectedRoute>
          <Inventario />
        </ProtectedRoute>
      }
    />
    <Route
      path="/admin-inventario-edit/:id"
      element={
        <ProtectedRoute>
          <InventarioEdit />
        </ProtectedRoute>
      }
    />
    <Route
      path="/admin-inventario-add"
      element={
        <ProtectedRoute>
          <InventarioAdd />
        </ProtectedRoute>
      }
    />

    </Routes>

    </AuthProvider>
  );
}

export default App;